import { Box, Container, Flex, Icon, Text } from '@chakra-ui/react';
import { ArrowCircleRightOutlined } from '@mui/icons-material';
import NextLink from 'next/link';

import { NOO_NAV_GRADIENT } from './NooRegistrationStatusConstants';

interface NooRegistrationStatusMobileSubHeaderProps {
  title: string;
  backHref?: string;
}

export function NooRegistrationStatusMobileSubHeader({
  title,
  backHref = '/noo-registration/status',
}: NooRegistrationStatusMobileSubHeaderProps) {
  return (
    <Box
      as="header"
      position="sticky"
      top={0}
      zIndex={10}
      bg="#FFFFFF"
      boxShadow="0 1px 4px #0000001A"
      display={{ base: 'block', lg: 'none' }}
      data-testid="noo-buyer-status-mobile-sub-header"
    >
      <Box pt="calc(1.5rem + env(safe-area-inset-top, 0px))">
        <Container maxW="390px" px={4} pb={4}>
          <Flex align="center" gap={2} minW={0}>
            <Flex
              as={NextLink}
              href={backHref}
              align="center"
              justify="center"
              w={8}
              h={8}
              shrink={0}
              aria-label="Kembali"
              transform="rotate(180deg)"
              color="#00003D"
            >
              <Icon as={ArrowCircleRightOutlined} boxSize={8} />
            </Flex>
            <Text
              flex={1}
              fontFamily="Ubuntu, sans-serif"
              fontSize="20px"
              fontWeight="medium"
              lineHeight="32px"
              letterSpacing="0.2px"
              color="#373F41"
              noOfLines={1}
            >
              {title}
            </Text>
          </Flex>
        </Container>
      </Box>
      <Box h="4px" bgGradient={NOO_NAV_GRADIENT} />
    </Box>
  );
}
